import { Table } from 'antd';
import type { TableProps } from 'antd/lib/table';

export type TopSalesManTableProps<TItem extends object = any> = Omit<TableProps<TItem>, 'pagination' | 'size'>;

export const TopSalesManTable = ({ columns, dataSource, ...props }: TopSalesManTableProps) => (
    <Table columns={columns} dataSource={dataSource} pagination={false} scroll={{ x: true }} size="small" {...props} />
);

export default TopSalesManTable;
